import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './GoogleLocation.module.scss';

//TODO: Results should look different than the marker that describes location
//TODO: Decide what to do on click, or allow for a link to be passed to link the title
const ResultMarker = ({ text, onClick, useTextbox }) => {
  const [showText, setShowText] = useState(false);

  const toggleText = () => {
    setShowText(!showText);
  };

  return (
    <>
      <div className={classes.locationPin} title={text} onClick={onClick || toggleText}>
        <FontAwesomeIcon icon={['fas', 'location-dot']} />
      </div>
      {(useTextbox || showText) && <span className={classes.textBox}>{text}</span>}
    </>
  );
};
ResultMarker.defaultProps = {
  onClick: null
};

ResultMarker.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired
};

export default ResultMarker;
